<template>
  <div class="undertakeOrder">
    <div class="clear">
      <h2 class="paging-title">承接工单</h2>
      <!-- <button class="btn-default" @click="download">导出数据</button> -->
      <button class="btn-default" @click="$router.push('/orderList')"><i>＋</i>接工单</button>
    </div>
    <div class="filter-form">
      <div class="form-item">
        <span class="label">城市：</span>
        <div class="input-item">
          <el-cascader
            size="mini"
            clearable
            v-model="city"
            :options="provinceList"
            :props="{
              children: 'cityList',
              label: 'name',
              value: 'ID',
            }"
          ></el-cascader>
        </div>
      </div>
      <div class="form-item">
        <span class="label">时间：</span>
        <div class="input-item">
          <el-date-picker
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="年-月-日"
            v-model="form.StartTime"
          ></el-date-picker>
          <i class="unit">至</i>
          <el-date-picker
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="年-月-日"
            v-model="form.EndTime"
          ></el-date-picker>
        </div>
      </div>
      <div class="form-item">
        <span class="label">搜索：</span>
        <div class="input-item">
          <input class="input" type="text" v-model.trim="form.SearchKey" placeholder="输入搜索内容"  @keydown.enter="search" />
        </div>
      </div>
      <div class="form-item" style="margin-bottom: 10px;">
        <span class="label">平台：</span>
        <div class="input-item">
          <label
            class="radiobox"
            v-for="(item, index) in radios"
            :key="index"
          >
            <input name="source" type="radio" :value="item.value" v-model="form.JobPlatform" @change="search" />
            <span class="radio-text">{{ item.label }}</span>
          </label>
        </div>
      </div>
      <div class="form-item" style="margin-bottom: 10px;">
        <span class="label">状态：</span>
        <div class="input-item">
          <label
            class="radiobox"
            v-for="(item, index) in stepType"
            :key="index"
          >
            <input name="status" type="radio" :value="item.JobStep" v-model="form.JobStep" @change="search" />
            <span class="radio-text">{{ item.JobStepText }} <i class="count" v-if="item.JobCount">({{item.JobCount}})</i></span>
          </label>
        </div>
      </div>
      <div class="btn-all">
        <button class="btn-filter-bg" @click="search">查询</button>
        <button class="btn-filter-no-bg" @click="download">导出数据</button>
      </div>
    </div>
    <!-- 外部工单 -->
    <table class="table">
      <tr>
        <th>工单名称</th>
        <th>来源</th>
        <th>城市</th>
        <th>发单时间</th>
        <th>服务时间</th>
        <th>金额/元</th>
        <th colspan="2">状态</th>
      </tr>
      <tr v-for="(item,index) in tableData" :key="index" @click="toDetail(item)">
        <td>
          <div>
            <h3 class="item-title">
              <i class="icon-urgent" v-if="item.IsUrgent"></i>
              <i class="icon-hot" v-if="item.IsHotJob"></i>
              {{item.JobTitle}}
            </h3>
            <p class="number-job">工单号：{{item.JobNo}}</p>
            <p class="number-job">产品：{{item.ProductCateName}}</p>
            <p class="number-job">品牌：{{item.BrandName}}</p>
          </div>
        </td>
        <td>{{item.PlatformName}}</td>
        <td>{{item.ProvinceName}}·{{item.CityName}}</td>
        <td>{{item.ReleaseDate}}</td>
        <td>{{item.ExecStartDate}}至<br />{{item.ExecEndDate}}</td>
        <td>{{item.JobStepAmount}}</td>
        <td>
          {{item.JobStatusName}}
          <div class="remark">
            {{item.JobStatusRemark}}
          </div>
        </td>
        <td>
          <span class="btn-chat" style="margin-bottom: 10px" v-if="item.EasemobGroupId" @click.stop="toChat(item)">群聊</span>
          <button v-if="item.IsShowInvoiceBtn" class="invoice-btn" @click.stop="$router.push({path:'/center/receivable'})">开票结款</button>
          <!-- <span class="btn-radius" @click.stop="again(item)">再来一单</span> -->
        </td>
      </tr>
      <tr v-if="tableData.length == 0">
        <td class="no-data" colspan="8">暂无数据</td>
      </tr>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="pageIndex"
      :page-size="pageSize"
      :total="total"
      @current-change="pageChange"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  DownPcMyPickJobList,
  GetPcMyPickJobList,
  GetPickJobStep,
  GetPcJobRouteUrl,
} from "@/scripts/api.js";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      radios: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "自由专区",
          value: 1,
        },
        {
          label: "B2B专区",
          value: 2,
        },
      ],
      stepType: [],
      pageSize: 10,
      pageIndex: 1,
      total: 0,
      form: {
        ProvinceId: 0,
        CityId: 0,
        StartTime: "",
        EndTime: "",
        SearchKey: "",
        JobPlatform:0,
        JobStep:0,
      },
      tableData: [],
      loading: false,
      city: [],
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      provinceList: (state) => state.provinceList,
    }),
  },
  watch: {
    city(val) {
      if (val.length) {
        this.form.ProvinceId = val[0];
        this.form.CityId = val[1];
      }else{
        this.form.ProvinceId = 0;
        this.form.CityId = 0;
      }
      this.search();
    },
  },
  created() {
    this.loadProvinceList();
    this.getTabs();
  },
  methods: {
    ...mapActions(["loadProvinceList"]),
    //获取状态列表
    getTabs(){
      GetPickJobStep({
        IsPc:true,
        loginCompanyId:this.userInfo.LoginAccountType==2?this.userInfo.LoginAccountId:0,
        loginUserId:this.userInfo.LoginAccountType==1?this.userInfo.LoginAccountId:0,
      }).then(r=>{
        if(r.Result==1){
          let data=r.Data;
          this.stepType=data?data.JobStepList:[];
          //如果有待承接或者服务中，跳转
          let id=0;//
          for (let i = 0; i < this.stepType.length; i++) {
            if(this.stepType[i].JobCount>0 && this.stepType[i].JobStep==1){
              id=1;
              break;
            }
            if(this.stepType[i].JobCount>0 && this.stepType[i].JobStep==3){
              id=3;
            }
          }
          this.form.JobStep=id;
          this.loadData();
        }
      })
    },
    search(){
      this.pageIndex=1;
      this.loadData();
    },
    //获取列表
    loadData() {
      if (this.loading) return;
      this.loading = true;
      let params = {
        PageNum: this.pageIndex,
        PageSize: this.pageSize,
        UserCode: this.userInfo.UserCode,
        ...this.form,
      };
      GetPcMyPickJobList(params).then((r) => {
        this.loading = false;
        if (r.Result == 1) {
          this.tableData = r.Data.JobList || [];
          this.total = r.Data.TotalCount;
        }else{
          this.$toast(r.Message);
        }
      });
    },
    //分页切换
    pageChange(data) {
      this.pageIndex = data;
      this.loadData();
    },
    //
    toDetail(item){
      // $router.push({path:'/pickOrderProcess',query:{jobNo:item.JobNo}})
      GetPcJobRouteUrl({
        UserCode:this.userInfo.UserCode,
        JobId:item.JobId,
      }).then(r=>{
        if(r.Result==1){
          let url=r.Data.PageUrl;
          window.open(url,'_blank');


          // this.$router.push({
          //   path:'/pickOrderProcess',
          //   // path:'/pickOrderInfo',
          //   query:{
          //     jobNo:item.JobNo
          //   }
          // })
        }else{
          this.$toast(r.Message);
        }
      })
    },
    //下载工单列表
    download() {
      let params = {
        UserCode: this.userInfo.UserCode,
        ...this.form,
        platform:'pcweb'
      };
      let str='';
      //拼接参数字符串
      for (const k in params) {
        if (Object.hasOwnProperty.call(params, k)) {
          str+=`${k}=${params[k]}&`
        }
      }
      DownPcMyPickJobList(str);
    },
    //群聊
    toChat(item){
      this.$router.push({
        path:'/chat/chatContent',
        query:{
          activeKey:'group',
          chatId:item.EasemobGroupId
        }
      })
    },
  },
};
</script>
<style lang="scss">
.undertakeOrder {
  .filter-form {
    background-color: #f8f8f8;
    padding: 25px 20px 0px;
    overflow: hidden;
    position: relative;
    padding-right: 90px;
    margin-top: 20px;
    .el-cascader {
      width: 160px;
    }
    .el-date-editor{
      width: 140px;
    }
    .form-item {
      margin-bottom: 16px;
      float: left;
      overflow: hidden;
      margin-right: 20px;
    }
    .btn-group {
      float: right;
    }
    .label {
      float: left;
      font-size: 14px;
      color: #666;
      line-height: 30px;
    }
    .input-item {
      float: left;
      min-width: 160px;
    }
    .input {
      width: 160px;
      border: 1px solid #e5e5e5;
      background-color: #fff;
      padding: 4px 10px;
      font-size: 14px;
      color: #333;
      line-height: 20px;
      height: 30px;
    }
    .unit{
      font-size: 14px;
      color: #666;
      line-height: 30px;
      padding-left: 5px;
      padding-right: 5px;
    }
    .radiobox {
      display: inline-block;
      margin-right: 40px;
      position: relative;
      margin-top: 3px;
      cursor: pointer;
      input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        font-size: 100px;
      }
      .radio-text {
        display: inline-block;
        padding: 0 16px;
        font-size: 14px;
        color: #666;
        border-radius: 2px;
        height: 24px;
        line-height: 24px;
        .count{
          color: #f75959;
        }
      }
      input:checked + .radio-text {
        background-color: #f75959;
        color: #fff;
        .count{
          color: #fff;
        }
      }
    }
    .btn-all {
      position: absolute;
      right: 20px;
      top: 25px;
      font-size: 14px;
      .btn-filter-bg {
        height: 30px;
        width: 60px;
        background-color: #f75959;
        color: #fff;
        cursor: pointer;
      }
      .btn-filter-no-bg {
        color: #f75959;
        margin-left: 4px;
        background: none;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .table {
    margin-top: 30px;
    border-collapse: collapse;
    border: 1px solid #e5e5e5;
    width: 100%;
    tr {
      border: 1px solid #e5e5e5;
      &:hover{
        td{
          background-color: #f8f8f8;
        }
      }
    }
    th {
      height: 48px;
      line-height: 48px;
      background-color: #f8f8f8;
      font-size: 14px;
      color: #333;
      text-align: left;
      min-width: 80px;
      font-weight: normal;
      &:nth-child(1) {
        // text-align: center;
        padding-left: 10px;
      }
    }
    td {
      padding: 5px 0;
      line-height: 24px;
      font-size: 14px;
      color: #333;
      text-align: left;
      .item-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        color: #333;
        font-weight: bold;
        line-height: 24px;
        max-width: 200px;
        min-width: 200px;
      }
      .number-job {
        font-size: 12px;
        color: #999;
        line-height: 22px;
      }
      &:nth-child(1) {
        width: 240px;
        padding-left: 10px;
      }
    }
    .time {
      word-break: break-all;
    }
    .price {
      color: #f75959;
    }
    .order-no {
      color: #999;
      font-size: 12px;
    }
    .status {
      font-size: 14px;
      color: #999;
      &.status1 {
        color: lightgreen;
      }
      &.status2 {
        color: #f75959;
      }
    }
    .icon-urgent {
      display: inline-block;
      vertical-align: middle;
      margin-right: 3px;
      width: 36px;
      height: 16px;
      background-image: url('~@/assets/icon-urgent.png');
      background-repeat: no-repeat;
      background-size: contain;
    }
    .icon-hot {
      display: inline-block;
      vertical-align: middle;
      margin-right: 3px;
      width: 26px;
      height: 14px;
      background-image: url('~@/assets/icon-hot.png');
      background-repeat: no-repeat;
      background-size: contain;
    }
    .remark{
      color: #666;
      font-size: 12px;
    }
    .btn-text {
      color: #333;
      font-size: 12px;
      cursor: pointer;
    }
    .btn-radius {
      display: block;
      width: 60px;
      height: 20px;
      margin: 0 auto;
      text-align: center;
      border: 1px solid #999;
      color: #333;
      font-size: 12px;
      line-height: 18px;
      border-radius: 20px;
      cursor: pointer;
      &:hover{
        color: #f75959;
        border-color: #f75959;
      }
    }
    .btn-chat{
      display: block;
      padding-left: 30px;
      background-image: url('~@/assets/icon-chat.png');
      background-repeat: no-repeat;
      background-size: 22px 21px;
      background-position: left center;
      width: 60px;
      margin: 0 auto 4px;
      cursor: pointer;
      font-size: 12px;
      line-height: 22px;
      color: #333;
      &:hover{
        color: #f75959;
      }
    }
  }
  .el-pagination {
    text-align: right;
    margin-top: 30px;
  }
}
.invoice-btn {
  border: 1px solid #f75959;
  line-height: 20px;
  height: 24px;
  font-size: 12px;
  border-radius: 12px;
  padding: 0 10px;
  background: #fff;
  color: #f75959;
  margin: 0 auto;
  display: block;
  cursor: pointer;
  &:hover {
    background: #f75959;
    color: #ffffff;
  }
}
</style>
